import { GlobalSearch } from '@trukt/ui/GlobalSearch';
import { SEARCH_PARAM_KEYS, useOrderListRouteSearchParams } from '../context';

interface OrderListHeaderProps {
  globalSearch: string;
  onInputChange: (value: string) => void;
}
export const OrderListHeader = ({ globalSearch, onInputChange }: OrderListHeaderProps) => {
  const [searchParams, setSearchParams] = useOrderListRouteSearchParams();
  return (
    <GlobalSearch
      initialValue={globalSearch}
      onSubmit={({ action, value }) => {
        if (action === 'submit' && value) {
          searchParams.set(SEARCH_PARAM_KEYS.GLOBAL_SEARCH, value);
        } else {
          searchParams.delete(SEARCH_PARAM_KEYS.GLOBAL_SEARCH);
        }

        setSearchParams(searchParams);
        onInputChange(value);
      }}
    />
  );
};
